<template>
  <div class="basket__side row">
    <div class="basket__side__image col-xs-4 col-md-12">
      <img :src="shoe.images[0]" />
    </div>
    <div class="basket__side__content col-xs-7 col-md-8">
      <h3>Récapitulatif</h3>
      <div class="basket__side__item">
        <div>Modèle :</div>
        <div>{{ shoe.name }}</div>
      </div>
      <div class="basket__side__item --color">
        <div>Coloris :</div>
        <div>{{ shoe.color }}</div>
      </div>
      <div class="basket__side__item">
        <div>Pointure :</div>
        <div>{{ user.size }} EU</div>
      </div>
      <div class="basket__side__item">
        <div>Valeur :</div>
        <div v-html="formatPrice(shoe.price)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@/plugins/helpers";
export default {
  name: "BasketResume",
  props: {
    shoe: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatPrice(cents) {
      return formatPrice(cents);
    }
  }
};
</script>

<style lang="scss">
.basket {
  &__side {
    background: #f6f6f6;
    // border: 2px solid #f6f6f6;
    justify-content: center;
    @media #{$md-and-down} {
      background: white;
      border: 1px solid #e2e2e2;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2rem;
      padding: 1rem;
    }
    &__image {
      > img {
        max-width: 100%;
      }
      @media #{$md-and-up} {
        // background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        // height: 20rem;
        > img {
          max-width: 50%;
        }
      }
    }
    &__content {
      > h3 {
        font-size: 1.8rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 2rem;
        @media #{$md-and-down} {
          display: none;
        }
      }
    }
    &__item {
      margin-right: 2rem;
      @media #{$md-and-up} {
        margin-bottom: 2rem;
      }
      @media #{$md-and-down} {
        display: inline-block;
        &.--color {
          display: none;
        }
      }
      > :first-child {
        font-weight: bold;
      }
    }
  }
}
</style>
